/* global ym */
import { listenToStartSearchTrackEvent as initTrackWidgetModal } from '../../components/TrackingWidget/TrackWidgetModal.vue';
import { factory as initMobileHeaderMenu } from '../../components/MobileHeaderMenu/MobileHeaderMenu.vue';
import { targetsYmOnAdvantages } from '../../helpers/targets-ym';
import { factory as personalAccountButtonFactory } from '../../components/PersonalAccountChoiceModal/PersonalAccountButton.vue';

import VueFactory from '../../helpers/vueFactory';
import mobileMountingComponent from '../../helpers/component-installer';
import initApplicationGlobal from '../Global/Global';
import initFormBar from '../../components/Formbar/Formbar';
import initCalc from './initCalc';

export default function initApplicationHomePage(eventHub) {
  initApplicationGlobal(eventHub);

  if (document.querySelector('#calculator')) {
    initCalc();
  }

  initTrackWidgetModal();

  const cityShow = document.getElementById('city-show');
  if (cityShow) {
    const OdpSearchWidget = () => import(
      /* webpackChunkName: "OdpSearchWidget" */
      '../../components/FindOdp/FindOdp.vue'
    );
    OdpSearchWidget().then((module) => {
      VueFactory(module.default, {
        el: cityShow.parentElement,
      });
    });
  }
  initFormBar();

  initMobileHeaderMenu({
    scrollToCalc: window.location.hash === '#calc',
  });

  const arrayIdTargets = ['pip_block_lk', 'pip_block_arrage_box', 'pip_block_safe_deal', 'pip_block_track_box', 'pip_block_stock_im'];

  targetsYmOnAdvantages(arrayIdTargets);

  personalAccountButtonFactory({
    classModifier: 'button-accounts_header-desktop',
    restorePopupMode: 'desktop',
  });

  if (document.querySelector('.filial .map_index')) {
    const MapWidget = () => import(
      /* webpackChunkName: "MapWidget" */
      '../../components/MapWidget/MapWidget.vue'
    );
    MapWidget().then((module) => {
      mobileMountingComponent('.filial .map_index')
        .then(() => {
          VueFactory(module.default, {
            el: '.filial .map_index',
            data: {
              eventHub,
            },
          });
        });
    });
  }

  document.addEventListener('reachGoal', (e) => {
    if (typeof ym !== 'undefined') {
      try {
        switch (e.detail.targetName) {
          case 'kz':
            ym(57872296, 'reachGoal', 'kz');
            break;
          case 'kd':
            ym(57872296, 'reachGoal', 'kd');
            break;
          case 'kz_kd':
            ym(57872296, 'reachGoal', 'kz_kd');
            break;
          default:
            break;
        }
      } catch (error) {
        console.error(error);
      }
    }
  });
}
